import React from 'react';
import { Box, Typography } from '@material-ui/core';

import { PlayerPageCard } from './player-page-card.component';

interface IRsvpCardProps {
  accent: string;
  headline: string;
  body: string;
  // Ice-time summary, rendered between the copy and the response controls.
  details?: React.ReactNode;
  children?: React.ReactNode;
}

// Centered card chrome shared by every state of the RSVP section.
export const RsvpCard: React.FC<IRsvpCardProps> = ({ accent, headline, body, details, children }) => (
  <PlayerPageCard padding="32px 28px" centered>
    <Box style={{ height: 4, background: accent, borderRadius: 2, marginBottom: 24 }} />
    <Typography variant="h5" gutterBottom>{headline}</Typography>
    <Typography variant="body1" color="textSecondary">{body}</Typography>
    {details && <Box mt={3}>{details}</Box>}
    {children && <Box mt={3}>{children}</Box>}
  </PlayerPageCard>
);
